import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { OrganizationPartnerItemFragment } from '@client/graphql/__generated__/types';
import { memo } from 'react';
import { useNavigate } from 'react-router';

interface PartnerCardProps {
  partner: OrganizationPartnerItemFragment;
}

export const PartnerCard = memo(function PartnerCard({
  partner,
}: PartnerCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/organizations/notifications/partners/${partner.id}`);
  };

  return (
    <Flex
      _hover={{ bg: 'whiteAlpha.100' }}
      alignItems="center"
      bg="whiteAlpha.50"
      border="1px solid"
      borderColor="whiteAlpha.100"
      borderRadius="lg"
      cursor="pointer"
      direction="column"
      height="130px"
      justifyContent="center"
      minWidth="130px"
      transition="background 0.2s"
      onClick={handleClick}
    >
      <Box
        alignItems="center"
        bg="white"
        borderRadius="sm"
        display="flex"
        height="50px"
        justifyContent="center"
        overflow="hidden"
        px={3}
      >
        {partner.logo?.url ? (
          <Image
            alt={partner.name}
            maxHeight="40px"
            maxWidth="100px"
            objectFit="contain"
            src={partner.logo.url}
          />
        ) : (
          <Text color="gray.800" fontSize="sm" fontWeight="medium">
            {partner.name}
          </Text>
        )}
      </Box>
      <Text color="whiteAlpha.700" fontSize="xs" mt={2} noOfLines={1} px={2}>
        {partner.name}
      </Text>
    </Flex>
  );
});
